import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CustomEventService } from '@shared/services/custom-event.service';

import { DayEnum } from '@shared/enums/day.enum';
import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { validateFormGroup } from '@shared/utils/form.util';

import { TIMEZONE, MINUTES, HOURS } from '@shared/variables/constant-variable';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html'
})
export class NotificationModalComponent implements OnInit {
  @Input() data?: Notification.NotificationModel;
  @Input() type: string;
  @Input() title: string;
  @Input() mode: string;
  @Input() loading: boolean;

  notificationTeamsForm?: FormGroup;
  notificationSlackForm?: FormGroup;

  day = DayEnum;
  dayOptions = [];
  activeTab: number;

  timezone = TIMEZONE;
  hours = HOURS;
  minutes = MINUTES;

  constructor(private fb: FormBuilder,
              private customEventService: CustomEventService) { }

  ngOnInit(): void {
    this.activeTab = this.data.messageAppType === 'MS_TEAMS' ? 0 : this.data.messageAppType === 'SLACK' ? 1 : 0;
    this.createTeamForm();
    this.createSlackForm();
    this.dayOptions = Object.keys(this.day);
  }

  createTeamForm(): void {
    const { webhookUrl, timePeriod, active } = this.data;

    this.notificationTeamsForm = this.fb.group({
      active: [active && this.data.messageAppType === 'MS_TEAMS' ? active : false, [Validators.required]],
      webhookUrl: [this.data.messageAppType !== 'MS_TEAMS' ? '' : webhookUrl, [Validators.required]],
      day: [this.data.messageAppType !== 'MS_TEAMS' ? '' : timePeriod?.day, [Validators.required]],
      hour: [this.data.messageAppType !== 'MS_TEAMS' ? '' : timePeriod?.hour, [Validators.required]],
      minute: [this.data.messageAppType !== 'MS_TEAMS' ? '' : timePeriod?.minute, [Validators.required]],
      timezone: [this.data.messageAppType !== 'MS_TEAMS' ? '' : timePeriod?.timezone, [Validators.required]]
    });
  }

  createSlackForm(): void {
    const { webhookUrl, timePeriod, active } = this.data;

    this.notificationSlackForm = this.fb.group({
      active: [active && this.data.messageAppType === 'SLACK' ? active : false, [Validators.required]],
      webhookUrl: [this.data.messageAppType !== 'SLACK' ? '' : webhookUrl, [Validators.required]],
      day: [this.data.messageAppType !== 'SLACK' ? '' : timePeriod?.day, [Validators.required]],
      hour: [this.data.messageAppType !== 'SLACK' ? '' : timePeriod?.hour, [Validators.required]],
      minute: [this.data.messageAppType !== 'SLACK' ? '' : timePeriod?.minute, [Validators.required]],
      timezone: [this.data.messageAppType !== 'SLACK' ? '' : timePeriod?.timezone, [Validators.required]]
    });
  }

  tabIndexChange($event: number): void {
    this.activeTab = $event;
  }

  submitForm(type: string, event: string): void {
    if (this.loading) {
      return;
    }

    if (event === 'team') {
      validateFormGroup(this.notificationTeamsForm);

      if (this.notificationTeamsForm.invalid) {
        return;
      }

      const formData = {
        id: this.data.id,
        active: this.notificationTeamsForm.value.active,
        receiverId: this.data.receiverId,
        webhookUrl: this.notificationTeamsForm.value.webhookUrl,
        receiverType: this.type === 'team' ? 'TEAM' : 'DEVELOPER',
        messageAppType: 'MS_TEAMS',
        notifierType: this.type === 'team' ? 'TEAM_SCORECARD' : 'DEVELOPER_SCORECARD',
        timePeriod: {
          day: this.notificationTeamsForm.value.day,
          hour: this.notificationTeamsForm.value.hour,
          minute: this.notificationTeamsForm.value.minute,
          timezone: this.notificationTeamsForm.value.timezone
        }
      }

      if (type === 'submit') {
        this.customEventService.announceEvent(this.mode === 'add' ? ActionTypesEnum.CREATE_NOTIFICATION : ActionTypesEnum.UPDATE_NOTIFICATION, formData);
      } else {
        this.customEventService.announceEvent(ActionTypesEnum.SEND_NOTIFICATION, formData);
      }
    } else {
      validateFormGroup(this.notificationSlackForm);

      if (this.notificationSlackForm.invalid) {
        return;
      }

      const formData = {
        id: this.data.id,
        active: this.notificationSlackForm.value.active,
        receiverId: this.data.receiverId,
        webhookUrl: this.notificationSlackForm.value.webhookUrl,
        receiverType: this.type === 'team' ? 'TEAM' : 'DEVELOPER',
        messageAppType: 'SLACK',
        notifierType: this.type === 'team' ? 'TEAM_SCORECARD' : 'DEVELOPER_SCORECARD',
        timePeriod: {
          day: this.notificationSlackForm.value.day,
          hour: this.notificationSlackForm.value.hour,
          minute: this.notificationSlackForm.value.minute,
          timezone: this.notificationSlackForm.value.timezone
        }
      }

      if (type === 'submit') {
        this.customEventService.announceEvent(this.mode === 'add' ? ActionTypesEnum.CREATE_NOTIFICATION : ActionTypesEnum.UPDATE_NOTIFICATION, formData);
      } else {
        this.customEventService.announceEvent(ActionTypesEnum.SEND_NOTIFICATION, formData);
      }
    }
  }

  resetForm(): void {
    this.activeTab === 0 ? this.createTeamForm() : this.createSlackForm();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }
}
